

import ourTeam from "@/mixins/data.js"
import ourMissionProducts from "@/mixins/data.js"
import featured from "@/mixins/data.js"



import ClientHead from "@/components/main/core/ClientHead";
import GreyHeadBox from "@/components/main/core/GreyHeadBox";
import RedSection from "@/components/main/core/RedSection";
import GreySection from "@/components/main/core/GreySection";
import BoxPhoto from "@/components/main/core/BoxPhoto";
import CheckBox from "@/components/main/core/CheckBox";


import anon from "@/assets/images/main/our-mission/team/anon.png"



export default {

  head() {
    const title = 'Learn More About iFindCheaters - Best Cheater Lookup Website';
    const description = 'Explore iFindCheaters, the leading cheater lookup website offering reliable and accurate information. Explore our products to uncover the truth about your partner\'s online activities. Protect your relationship with our reliable tools. Start investigating now!';

    return {
      title: title,
      meta: [
      {
          hid: 'og:title',
          property: 'og:title',
          content: title
        },
        {
          hid: 'description',
          name: 'description',
          content: description
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'Look Up Cheaters Online, Cheating Online, Catch a Cheating Partner Online, websites for catching cheaters, Best Cheater Lookup Websites, catch cheating spouse, hidden profile finder, find hidden dating profiles, verify spouse online, online infidelity search, detect cheating partner, find spouse on dating sites, catch cheating partner'
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: title
        }
      ],
      link: [
        {
          hid: "preload",
          rel: "preload",
          as: "image",
          href: require("@/assets/images/main/sample-report-bcg.webp"),
        },
        {
          hid: "canonical",
          rel: "canonical",
          href: "https://ifindcheaters.com/about-us/",
        },
      ],
      script: [
        {
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "iFindCheaters",
              "item": "https://ifindcheaters.com/"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "About Us ᐈ iFindCheaters",
            }],
          }
        }
      ]
    };
  },

  name: "about-us",
  layout: 'clientLayout',
  components: { ClientHead, GreyHeadBox, BoxPhoto, GreySection, RedSection, CheckBox,  },
  mixins: [ ourTeam, ourMissionProducts, featured ],
  data() {
    return {
      isAccepted: false,
      anon,

    }
  },

  methods: {
    accept() {
      this.isAccepted = !this.isAccepted
    },
  },

  mounted() {
    this.isAccepted = false;
  }
}
